import { ApiEnvironment } from '../../models/api-environment';

export class CpihEnvironment extends ApiEnvironment {
  get validateUrl() {
    return `${this.baseUrl}/api/validate`;
  }

  override resolve(environment: unknown) {
    return environment instanceof CpihEnvironment ? environment : this;
  }
}

export const ciphEnvironment = new CpihEnvironment();
